// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpeakerVideo__container-dc5229 {
  flex: 1 0;
  height: 100%;
  display: flex;
  padding: 8px;
  box-sizing: border-box;
}

.SpeakerVideo__speaker-c331e9 {
  flex: 1;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.SpeakerVideo__video-container-cba0c3 {
  border-radius: 8px;
  height: 100%;
  width: 100%;
}

.SpeakerVideo__toggle-opponents-c1e43c {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 56px;
  z-index: 2;
  cursor: pointer;
}

.SpeakerVideo__toggle-opponents-c1e43c:hover .SpeakerVideo__icon-bdddc0 {
  background-color: var(--addition-110_50);
}

.SpeakerVideo__toggle-opponents-c1e43c:active .SpeakerVideo__icon-bdddc0 {
  background-color: var(--addition-110_60);
}

.SpeakerVideo__icon-bdddc0 {
  border-radius: 50%;
  fill: var(--addition-50);
  padding: 8px;
  background-color: var(--addition-110_40);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/FullScreenCallView/Shared/SpeakerVideo/SpeakerVideo.styles.m.css"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;AACF;;AAEA;EACE,OAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;AACF;;AAEA;EACE,wCAAA;AACF;;AAEA;EACE,wCAAA;AACF;;AAEA;EACE,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,wCAAA;AACF","sourcesContent":[".container {\n  flex: 1 0;\n  height: 100%;\n  display: flex;\n  padding: 8px;\n  box-sizing: border-box;\n}\n\n.speaker {\n  flex: 1;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.video-container {\n  border-radius: 8px;\n  height: 100%;\n  width: 100%;\n}\n\n.toggle-opponents {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 56px;\n  z-index: 2;\n  cursor: pointer;\n}\n\n.toggle-opponents:hover .icon {\n  background-color: var(--addition-110_50);\n}\n\n.toggle-opponents:active .icon {\n  background-color: var(--addition-110_60);\n}\n\n.icon {\n  border-radius: 50%;\n  fill: var(--addition-50);\n  padding: 8px;\n  background-color: var(--addition-110_40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SpeakerVideo__container-dc5229`,
	"speaker": `SpeakerVideo__speaker-c331e9`,
	"video-container": `SpeakerVideo__video-container-cba0c3`,
	"videoContainer": `SpeakerVideo__video-container-cba0c3`,
	"toggle-opponents": `SpeakerVideo__toggle-opponents-c1e43c`,
	"toggleOpponents": `SpeakerVideo__toggle-opponents-c1e43c`,
	"icon": `SpeakerVideo__icon-bdddc0`
};
module.exports = ___CSS_LOADER_EXPORT___;
